const currency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
})

export const formatPrice = (value: number): string => {
    return currency.format(value)
}
